module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAANpJREFUWEftlz0OwjAMRj9L3ZjZOQFiYUMCLsFFKnkFRvsqDBwBFg7QlQMwwFKJAxghdWBIm1AKHXBW/+TpKXISEpENEa3R4TKzW5ZlszzPz7G2pKoWS2oZPzLzMlbrAG7ADfyHAVU9BOZBaWbFTwxUAIsAxKVvADiAG3ADbqB/AyJyJaJh7O3WIr5j5tWzrmEUg6pX8bzFBrUlRHQ3M2HmUxSgy43reqlqAWAcitO3AWL/jiSAmvs8hX0AYNqU+A5A6D5PgWjMcQA3kGpgAmAPYPTxqXtpYGbbB6eywB4kyyx4AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/course/pasete.png
// module id = rz4b
// module chunks = 4